import React from 'react';

// material-ui
import { Box, List, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';
import { GenericCardProps, DefaultRootStateProps } from 'src/types';
import { adminTokens } from 'src/views/common/adminTokens';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

export interface NavGroupProps {
    item: {
        id?: string;
        type?: string;
        icon?: GenericCardProps['iconPrimary'];
        children?: NavGroupProps['item'][];
        title?: React.ReactNode | string;
        caption?: React.ReactNode | string;
        color?: 'primary' | 'secondary' | 'default' | undefined;
    };
    index: number
}

const NavGroup = ({ item, index }: NavGroupProps) => {
    const drawerOpen: boolean = useSelector((state: DefaultRootStateProps) => state.customization.opened)

    // menu list collapse & items
    const items = item.children?.map((menu) => {
        switch (menu.type) {
            case 'collapse':
                return <NavCollapse key={menu.id} menu={menu} level={1} />;
            case 'item':
                return <NavItem key={menu.id} item={menu} level={1} />;
            default:
                return (
                    <Typography key={menu.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <List
            sx={{
                padding: 0,
                marginTop: index === 0 ? 0 : 1.5,
                display: !drawerOpen ? 'flex' : 'block',
                flexDirection: !drawerOpen ? 'column' : undefined,
                alignItems: !drawerOpen ? 'center' : undefined,
                gap: !drawerOpen ? '2px' : 0,
            }}
            subheader={
                item.title && drawerOpen ? (
                    <Box sx={{ padding: '0 12px 6px' }}>
                        <Typography
                            component="span"
                            sx={{
                                fontFamily: adminTokens.fontSans,
                                fontSize: 11,
                                fontWeight: 600,
                                letterSpacing: '.06em',
                                textTransform: 'uppercase',
                                color: adminTokens.gray500,
                            }}
                        >
                            {item.title}
                        </Typography>
                    </Box>
                ) : undefined
            }
        >
            {items}
        </List>
    );
};

export default NavGroup;
